import React from 'react';
import { Helmet } from 'react-helmet-async';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { LayoutDashboard, Users, Truck, ShieldAlert, Map, Mail, Settings, BarChart, Send, BellRing, Annoyed, Coins, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import Divider from '@/components/ui/divider';
import { adminSidebarLinks } from '@/config/adminSidebarLinks';

const AdminCommunications = () => {
  const handleNotImplemented = () => toast({ title: '🚧 Bientôt disponible!' });

  return (
    <>
      <Helmet><title>Communications - LogiConnect</title></Helmet>
      <DashboardLayout sidebarLinks={adminSidebarLinks}>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-6">Notifications & Communications</h1>
        
        {/* Divider */}
        <Divider variant="gradient" icon={MessageCircle} label="Canaux de Communication" />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-card border border-border rounded-xl p-6">
                <Send className="w-8 h-8 text-secondary mb-4"/>
                <h2 className="text-xl font-bold text-foreground mb-2">Campagnes Email</h2>
                <p className="text-muted-foreground mb-4">Envoyez des emails marketing ou informatifs à vos utilisateurs.</p>
                <Button onClick={handleNotImplemented} className="w-full sm:w-auto gradient-secondary text-secondary-foreground font-semibold">Créer une campagne</Button>
            </div>
            <div className="bg-card border border-border rounded-xl p-6">
                <BellRing className="w-8 h-8 text-secondary mb-4"/>
                <h2 className="text-xl font-bold text-foreground mb-2">Notifications Push</h2>
                <p className="text-muted-foreground mb-4">Diffusez des notifications instantanées sur les appareils mobiles.</p>
                <Button onClick={handleNotImplemented} className="w-full sm:w-auto gradient-secondary text-secondary-foreground font-semibold">Envoyer une notification</Button>
            </div>
            <div className="bg-card border border-border rounded-xl p-6 md:col-span-2">
                <Annoyed className="w-8 h-8 text-secondary mb-4"/>
                <h2 className="text-xl font-bold text-foreground mb-2">Annonces de Maintenance</h2>
                <p className="text-muted-foreground mb-4">Prévenez les utilisateurs d'une maintenance programmée.</p>
                <Button onClick={handleNotImplemented} className="w-full sm:w-auto gradient-secondary text-secondary-foreground font-semibold">Programmer une annonce</Button>
            </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default AdminCommunications;
